import React from 'react';
import {useSelector} from 'react-redux';

import PopupWarning from '../../../components/Popup/PopupWarning';
import ModalTypes from '../../../enums/app/modalTypes';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import modalService from '../../../services/modalService';
import {makeSelectDeviceName} from '../../../state/selectors/consumer';

const OutsideClickPopup = (props) => {
    const {clickedLinkHref, popupKeys} = props;

    const deviceName = useSelector(makeSelectDeviceName());

    const localizedStrings = getLocalizedStrings();

    const onContinueBtnClick = () => {
        modalService.hideModal(ModalTypes.OUTSIDE_CLICK_POPUP);
    };

    const onExitBtnClick = () => {
        if (clickedLinkHref) {
            window.location.href = clickedLinkHref;
        }
    };
    const {titleKey, descriptionKey, buttonPrimary, buttonSecondary} = popupKeys || {};

    return (
        <PopupWarning
            contentLabel={localizedStrings[titleKey]}
            titleKey={titleKey}
            descriptionText={localizedStrings.formatString(localizedStrings[descriptionKey], deviceName)}
            buttonPrimary={{
                isConnectionTrack: true,
                onClick: onContinueBtnClick,
                textKey: buttonPrimary,
            }}
            buttonSecondary={{
                onClick: onExitBtnClick,
                textKey: buttonSecondary,
            }}
        />
    );
};

export default OutsideClickPopup;
